import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Alert } from 'react-bootstrap';
import NoQrScanReason from './NoQrScanReason';
import { useCheckoutJob } from '../../hooks/useJobs';
import { QrCodeScanner, VIBRATE_DURATION } from '../QrCodeScanner';

function ScanQRCodeDialogContent({ job, nextPage, updateJob, closeDialog, valves }) {

    ScanQRCodeDialogContent.propTypes = {
        job: PropTypes.object,
        nextPage: PropTypes.func,
        updateJob: PropTypes.func,
        closeDialog: PropTypes.func,
        valves: PropTypes.object
    };

    const { undoCheckoutJob } = useCheckoutJob();
    const [nextButtonDisabled, setNextButtonDisabled] = useState(true);

    const [qrScanResult, setQrScanResult] = useState();
    const [previousQrScanResult, setPreviousQrScanResult] = useState();
    const [foundKnownValve, setFoundKnownValve] = useState();
    const [qrScanMessage, setQrScanMessage] = useState();

    const [noQrScanReason, setNoQrScanReason] = useState({});

    const guidEquals = (guid, scannedGuid) => {
        return guid?.toLowerCase() === scannedGuid?.toLowerCase();
    };

    useEffect(() => {
        if (qrScanResult !== previousQrScanResult) {

            const canVibrate = window.navigator.vibrate;
            if (canVibrate) {
                navigator.vibrate(VIBRATE_DURATION);
            }

            console.debug("New QR code scanned: " + qrScanResult);

            var scannedValve = valves.find((valve) => guidEquals(valve.guid, qrScanResult));

            // Scan was successful if we scanned a known valve
            setFoundKnownValve(scannedValve !== undefined);
            setPreviousQrScanResult(qrScanResult);
            setNoQrScanReason({ selectedReason: "", otherReason: "" });

            if (scannedValve) {
                setQrScanMessage(`Valid QR Code for valve ${scannedValve.tag}`);
                setNextButtonDisabled(false);
            }
            else {
                setQrScanMessage("Invalid QR Code. Does not match a known valve");
                setNextButtonDisabled(true);
            }
        }
    }, [previousQrScanResult, qrScanResult, valves]);


    const handleQrResult = (result) => {
        if (result !== undefined) {
            setQrScanResult(result[0].rawValue);
        }
    };

    // A reason for not scanning is selected
    const handleNoScanReason = (reason) => {
        // Reason has been selected so reset the qr scan results
        setQrScanResult(undefined);
        setFoundKnownValve(undefined);
        setQrScanMessage(undefined);

        // Set the no scan reason in the job
        job.noQrScanReason = reason.selectedReason === "Other" ? reason.otherReason : reason.selectedReason;

        setNoQrScanReason(reason);

        // Disable next button if no reason is selected
        let disableNextButton = reason.selectedReason === "" || (reason.selectedReason === "Other" && reason.otherReason === "");
        setNextButtonDisabled(disableNextButton);
    };

    const undoCheckoutJobAndClose = async () => {

        job = await undoCheckoutJob(job)

        if (job) {
            updateJob(job);
        }

        closeDialog();

        // add error handling for task and undo checkout
    };

    return (
        <>
            <Modal.Body>
                <QrCodeScanner onScan={handleQrResult} classNames={{ container: "scanner", video: "scanner" }} />
                {qrScanMessage &&
                    <Alert variant={foundKnownValve ? "success" : "danger"} className="mt-2">{qrScanMessage}</Alert>
                }
                <NoQrScanReason reason={noQrScanReason} handleCallback={handleNoScanReason} />
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <Button variant="warning" style={{ color: 'white' }} onClick={undoCheckoutJobAndClose}>Undo Checkout</Button>
                <Button variant="primary" onClick={nextPage} disabled={nextButtonDisabled}>Next</Button>
            </Modal.Footer>
        </>
    );
}

export default ScanQRCodeDialogContent;
